import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { EducationService } from '../../services/education.service';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, ValidationErrors, FormControl, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { PrintService } from '../../services/print.service'

@Component({
	selector: 'app-voucher-report',
	templateUrl: './voucher-report.component.html',
	styleUrls: ['./voucher-report.component.scss']
})
export class VoucherReportComponent implements OnInit{
	color: any = 'blue';
	programs: any = [];
	searchForm: UntypedFormGroup;
	reportResults: any = [];
	sending: any = false;
	loading: any = false;
	totals: any = [];
	sortedReportResults: any = [];
	sortByColumn: string;
	sortDirection: string;
	
	constructor(private _changeDetectorRef: ChangeDetectorRef, private fb: UntypedFormBuilder, private educationService: EducationService, private globalSearchService: GlobalSearchService,  private printService: PrintService) {
		this.color = this.globalSearchService.getColor();
		
	}
	
	ngOnInit(){
		this.educationService.getRewards().subscribe((r) => {
			this.programs = r;
		});
		this.searchForm = this.fb.group({
			'voucher': [],
			'startdate': ['', Validators.required],
			'enddate':['', Validators.required],
		});
	}
	
	sortBy(field: any){
	
	}
	
	vouchers(){
		this.loading = true;
		this.educationService.getVoucherReport(this.searchForm.value).subscribe((p: any) => {
			this.loading = false;
			this.reportResults = p;
			this.sortedReportResults= p;
		});
	}
}
